import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import "./Profile.css";
import axios from "axios";
import Usernav from "./Usernav";
import Sellernav from "./Sellernav";
import Adminnav from "./Adminnav";
import BaseURL from "../Util/BaseURL";
const Profile = () => {
  const [name, setName] = useState();
  const [userName, setUserName] = useState();
  const [userEmail, setEmail] = useState();
  const [userPassword, setPassword] = useState();
  const init = async () => {
    const res = await axios.get(
      `${BaseURL}FindByName?name=${sessionStorage.getItem("user")}`
    );
    setUserName(res.data[0].userName);
    setName(res.data[0].name);
    setEmail(res.data[0].email);
    setPassword(res.data[0].userPassword);
  };
  useEffect(() => {
    init();
  });
  var nav = useNavigate();
  function navigate() {
    sessionStorage.clear();
    nav("/Login");
  }
  function myOrders() {
    nav("/MyOrders");
  }
  return (
    <>
      {sessionStorage.getItem("c") === "User" ? (
        <Usernav />
      ) : sessionStorage.getItem("c") === "Seller" ? (
        <Sellernav />
      ) : sessionStorage.getItem("c") === "Admin" ? (
        <Adminnav />
      ) : (
        <Usernav />
      )}
      <div className="padding mx-auto">
        <div className="row justify-content-center">
          <div className="col-xl-6 col-md-12">
            <div className="card user-card-full full">
              <div className="row m-l-0 m-r-0 text-center">
                <div className="col-sm-4 bg-c-lite-green user-profile le">
                  <div className="card-block text-center text-white">
                    <div className="m-b-25">
                      <i className="fas fa-user-tag userIco"></i>
                    </div>
                    <h6 className="f-w-600">{name}</h6>
                    <p>{sessionStorage.getItem("c")}</p>
                    <i className=" mdi mdi-square-edit-outline feather icon-edit m-t-10 f-16"></i>
                  </div>
                </div>
                <div className="col-sm-8">
                  <div className="card-block">
                    <h6 className="m-b-20 p-b-5 b-b-default f-w-600">
                      Information
                    </h6>
                    <div className="row">
                      <div className="col-sm-6">
                        <p className="m-b-10 f-w-600">Name</p>
                        <h6 className="text-muted f-w-400">{name}</h6>
                      </div>
                      <div className="col-sm-6">
                        <p className="m-b-10 f-w-600">Username</p>
                        <h6 className="text-muted f-w-400">{userName}</h6>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <p className="m-b-10 f-w-600">Email</p>
                        <h6 className="text-muted f-w-400">{userEmail}</h6>
                      </div>
                      <div className="col-sm-6">
                        <p className="m-b-10 f-w-600">Password</p>
                        <h6 className="text-muted f-w-400">***************</h6>
                      </div>
                    </div>

                    <div className="row">
                      {sessionStorage.getItem("c") === "User" ? (
                        <>
                          <div className="">
                            <button
                              onClick={() => myOrders()}
                              type="button"
                              className="btn btn-primary mx-auto m-0 d-block d-xl-none d-lg-none d-md-none"
                            >
                              My Orders
                            </button>
                            <button
                              onClick={() => myOrders()}
                              type="button"
                              className="btn btn-primary d-none d-xl-block d-lg-block d-md-block"
                            >
                              My Orders
                            </button>
                            <button
                              onClick={navigate}
                              type="button"
                              style={{ marginTop: "10%" }}
                              className="btn btn-primary mx-auto  d-block d-xl-none d-lg-none d-md-none"
                            >
                              Log Out
                            </button>
                            <button
                              onClick={navigate}
                              type="button"
                              style={{ marginTop: "3%" }}
                              className="btn btn-primary mx-auto d-none d-xl-block d-lg-block d-md-block"
                            >
                              Log Out
                            </button>
                          </div>
                        </>
                      ) : (
                        <>
                          <button
                            onClick={navigate}
                            type="button"
                            style={{ marginTop: "10%" }}
                            className="btn btn-primary mx-auto btn btn-primary mx-auto m-0 d-block d-xl-none d-lg-none d-md-none"
                          >
                            Log Out
                          </button>
                          <button
                            onClick={navigate}
                            type="button"
                            style={{ marginTop: "3%" }}
                            className="btn btn-primary mx-auto d-none d-xl-block d-lg-block d-md-block"
                          >
                            Logout
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
